import { gql } from '__generated__/gql';

export const AUTH_CHALLENGE = gql(/* GraphQL */ `
  mutation AuthChallenge($input: AuthChallengeInput!) {
    authChallenge(input: $input) {
      data {
        ...AuthSession
      }
      challenge {
        ...AuthChallenge
      }
      success
      error
    }
  }
`);
